<button class="demooz_button" 
    [type]="this.typeButton" 
    [class.text_only]="this.iconButton === '' && !this.isFetching"
    [class.icon_only]="this.labelButton === ''"
    [class.rounded]="this.roundedButton"
    [class.disabled]="this.disabledButton || this.isFetching"
    [class.hide_phone]="this.hideLabelDevice === 'phone'"
    [class.hide_tablet]="this.hideLabelDevice === 'tablet'"
    [class.full_size]="this.fullSize"
    [class.with_margin]="this.withMargin"
    [class.with_shadow]="this.withShadow"
    [class.with_border]="this.withBorder"
    [class.big]="this.sizeButton === 'big'"
    [class.small]="this.sizeButton === 'small'"
    [class.primary]="this.colorButton === 'primary'"
    [class.secondary]="this.colorButton === 'secondary'"
    [class.blue]="this.colorButton === 'blue'"
    [class.red]="this.colorButton === 'red'"
    [class.green]="this.colorButton === 'green'"
    [class.orange]="this.colorButton === 'orange'"
    [class.purple]="this.colorButton === 'purple'"
    [class.inverted_color]="this.invertColor"
    [disabled]="this.disabledButton || this.isFetching"
    >    
    @if(this.isFetching){
        <ion-spinner></ion-spinner>
    }
    @else{
        @if(this.iconButton !== ''){
            <ion-icon [name]="this.iconButton"></ion-icon>
        }
    }
    @if(this.labelButton !== ''){
        <div class="demooz_button_label">{{this.labelButton}}</div>
    }    
</button>